import { Button } from 'antd';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  font-size: 14px;
  height: 37px;
  border: none;
  box-shadow: -1px 2px 8px 0px rgba(39, 111, 175, 0.16);
  -webkit-box-shadow: -1px 2px 8px 0px rgba(39, 111, 175, 0.16);
  -moz-box-shadow: -1px 2px 8px 0px rgba(39, 111, 175, 0.16);
`;
